import {
  LocationOn as AddressIcon,
  PersonOutlined as PersonIcon,
  StoreOutlined as StoreIcon,
} from '@mui/icons-material';

interface ShippingDetailsProps {
  destinationAddress: {
    streetName: string;
    doorNumber: string;
    apartmentNumber: string | null;
    lat: string | null;
    long: string | null;
  } | null;
  customerName: string | undefined;
  commerceName: string | undefined;
}

const ShippingDetails = ({ destinationAddress, customerName, commerceName }: ShippingDetailsProps) => {
  const formattedAddress = destinationAddress
    ? `${destinationAddress.streetName || ''} ${destinationAddress.doorNumber || ''} ${
        destinationAddress.apartmentNumber ? `Apt ${destinationAddress.apartmentNumber}` : ''
      }`.trim()
    : 'Sin dirección';

  return (
    <div className='flex flex-col items-start gap-1.5'>
      {customerName && (
        <div className='flex items-center gap-1.5 text-sm text-gray-500 font-bold'>
          <PersonIcon sx={{ fontSize: 16 }} />
          {customerName}
        </div>
      )}
      <div className='flex items-center gap-1.5 text-sm text-gray-500 font-bold'>
        <AddressIcon sx={{ fontSize: 16 }} />
        {formattedAddress}
      </div>
      {commerceName && (
        <div className='flex items-center gap-1.5 text-sm text-gray-500 font-bold'>
          <StoreIcon sx={{ fontSize: 16 }} />
          {commerceName}
        </div>
      )}
    </div>
  );
};

export default ShippingDetails;
